<template>
  <div>
    <!-- <jet-banner /> -->

    <div class="min-h-screen flex flex-col justify-between">
      <div class="relative flex flex-col flex-grow">
        <nav-menu class="z-50" :home="isHome"></nav-menu>

        <!-- Page Content -->
        <main class="relative flex flex-col justify-center flex-grow z-10">
          <div
              class="bg-dark-blue h-3/4 lg:h-2/3 lg:min-h-30rem w-auto lg:w-4/5 max-h-2/3 absolute inset-0 z-0 -ml-4 flex flex-col items-center justify-end"
              v-if="page !== 'home'">
            <div class="flex justify-between w-3/4 bottom-0">
              <p class="text-5xl lg:text-10xl font-bastia font-bold select-none transform -translate-x-40"
                 style="color:#263b67;">Coach</p>
            </div>
          </div>
          <div class="z-10 relative" :class="{ 'pt-24 lg:pb-34 px-4 lg:px-10' : !isHome }">
            <slot></slot>
          </div>
        </main>
      </div>

      <footer-tc :home="isHome"></footer-tc>

      <a v-if="user && user.role === 'admin'"
         class="fixed bottom-12 right-12 px-6 py-4 rounded-lg bg-red-400 text-white font-bold z-50"
         href="/admin"
      >
        Admin
      </a>
    </div>
  </div>
</template>

<script>
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'
import NavMenu from '@/Components/NavMenu'
import FooterTc from '@/Components/FooterTc'

export default {
  components: {
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    JetResponsiveNavLink,
    NavMenu,
    FooterTc
  },
  props: ['page', 'user'],
  computed: {
    isHome() {
      return this.page === "home"
    }
  },
  mounted() {
    // const header = document.querySelector('.header-content')
    // const nav = document.querySelector('nav')
    // document.addEventListener('scroll', function () {
    //     if(header.getBoundingClientRect().top < 70) {
    //         nav.classList.add('nav-white');
    //     } else {
    //         nav.classList.remove('nav-white');
    //     }
    // })
  }
}
</script>

<style lang="scss" scoped>
</style>
